import { format } from 'date-fns';

/**
 * Formats an ISO date as `MMM d, yyyy`.
 */
export const formatDate = (value: string) => format(new Date(value), 'MMM d, yyyy');
